import { render, staticRenderFns } from "./ReportFooter.vue?vue&type=template&id=a7445d64&scoped=true"
import script from "./ReportFooter.vue?vue&type=script&lang=js"
export * from "./ReportFooter.vue?vue&type=script&lang=js"
import style0 from "./ReportFooter.vue?vue&type=style&index=0&id=a7445d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7445d64",
  null
  
)

export default component.exports